/**
 * Send a custom GA4 event.
 *
 * The gtag script is loaded by util/includeScripts.js and only collects once
 * the visitor has consented (Google Consent Mode defaults to "denied" — see
 * public/static/scripts/gcm-consent-defaults.js), so callers never have to
 * check consent themselves: if there is no consent, gtag queues nothing
 * identifiable, and if there is no gtag at all (analytics not configured,
 * server render, tests) this is a no-op.
 *
 * Reusable for any UI event we want to measure; keep names to GA4's
 * recommended-event vocabulary where one fits (e.g. `share`, `select_item`)
 * so the reports come for free.
 *
 * @param {string} name - GA4 event name
 * @param {Object} [params] - event parameters
 */
export const trackEvent = (name, params = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }
  try {
    window.gtag('event', name, params);
  } catch (e) {
    // Analytics must never break the UI.
  }
};
